var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.05 173.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bell-cls-1{fill:#fb9927;}.bell-cls-2{fill:#f98824;}.bell-cls-3{fill:#fcb44d;}.bell-cls-4{fill:#fcc16d;}.bell-cls-5{fill:#fca62f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "bell-cls-1",
    cx: 64.53,
    cy: 150.81,
    r: 22.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-1",
    d: "M92.65,202.94a22.38,22.38,0,0,0,18.9-10.41H73.75A22.36,22.36,0,0,0,92.65,202.94Z",
    transform: "translate(-28.12 -29.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-2",
    d: "M92.65,158.13a22.37,22.37,0,0,0-18.9,34.4h37.8a22.38,22.38,0,0,0-18.9-34.4Z",
    transform: "translate(-28.12 -29.41)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-3",
    d: "M144.75,161.59c0-4.56-3.05-8.16-5.5-10.31a8.76,8.76,0,0,1-3-6.58V109.93c0-24.54-20.09-45.09-44.63-44.62A43.76,43.76,0,0,0,48.7,109.07V144.7a8.76,8.76,0,0,1-3,6.58c-2.45,2.15-5.5,5.75-5.5,10.31v7.64l8.51.08v.17h87.54v-.17l8.51-.08Z",
    transform: "translate(-28.12 -29.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bell-cls-4",
    x: 0.41,
    y: 138.8,
    width: 128.64,
    height: 18.86,
    rx: 9.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-5",
    d: "M139.58,150.94a8.79,8.79,0,0,1-3-6.6V109.46c0-24.62-20.15-45.24-44.77-44.77-.44,0-.88,0-1.31.06,22.12,1.14,38.67,20.54,38.67,43.52v36.51A8.61,8.61,0,0,0,132,151.2c2.35,2.1,5.28,3.06,5.28,7.52v4.91l-8.16.08v.16h-84v-.16l-5-.05v5.28l8.54.09v.17h87.82V169l8.54-.09v-7.65C145.1,156.71,142,153.1,139.58,150.94Z",
    transform: "translate(-28.12 -29.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-3",
    d: "M45.17,163.87h84v-.16l8.16-.08v-4.91c0-4.46-2.93-5.42-5.28-7.52a8.61,8.61,0,0,1-2.88-6.42V108.27c0-23-16.55-42.38-38.67-43.52a43.9,43.9,0,0,0-41.74,43.84v35.75a8.83,8.83,0,0,1-3,6.6c-2.46,2.16-5.52,5.77-5.52,10.35v2.37l5,.05Z",
    transform: "translate(-28.12 -29.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-3",
    d: "M147.71,168.15h-8.33a9.46,9.46,0,1,1,0,18.92h8.33a9.46,9.46,0,0,0,0-18.92Z",
    transform: "translate(-28.12 -29.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-4",
    d: "M148.84,177.61a9.46,9.46,0,0,0-9.46-9.46H37.58a9.46,9.46,0,0,0,0,18.92h101.8A9.47,9.47,0,0,0,148.84,177.61Z",
    transform: "translate(-28.12 -29.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-cls-1",
    d: "M92.65,29.41A17.8,17.8,0,1,0,110.44,47.2,17.8,17.8,0,0,0,92.65,29.41Zm0,25.83a8,8,0,1,1,8-8A8,8,0,0,1,92.65,55.24Z",
    transform: "translate(-28.12 -29.41)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9a8dfaf602e0098b65594fc935e4bb34.svg";
export { ForwardRef as ReactComponent };